//eslint-disable-next-line no-restricted-imports
import type DxfArrayScanner from '../../DxfArrayScanner';
//eslint-disable-next-line no-restricted-imports
import type { IGroup, GroupValue } from '../../DxfArrayScanner';
//eslint-disable-next-line no-restricted-imports
import { serializeGroupValue } from '../../DxfArrayScanner';
//eslint-disable-next-line no-restricted-imports
import { groupIs } from '../../ParseHelpers';
//eslint-disable-next-line no-restricted-imports
import { DXFSymbol } from '../../constants';

type CodeValueEntry = [number, GroupValue];

//ISomeTable is captured so we can accurately parse and serialize (roundtrip) a DXF and read it in other DXF readers that require these tables (ie eDrawings)
//(These tables shouldn't be strictly required by most readers)
export type ISomeTable = {
  name: string;
  codeValueEntries: CodeValueEntry[];
};

export const parseSomeTable = (scanner: DxfArrayScanner): ISomeTable => {
  let curr = scanner.lastReadGroup as IGroup<GroupValue>;
  const someTable: ISomeTable = {
    name: curr.value as string,
    codeValueEntries: [],
  };
  curr = scanner.next();
  while (!groupIs(curr, 0, DXFSymbol.EndTable)) {
    someTable.codeValueEntries.push([curr.code, curr.value]);
    curr = scanner.next();
  }
  return someTable;
};

export const serializeSomeTable = function* ({
  name,
  codeValueEntries,
}: ISomeTable): IterableIterator<string> {
  yield '0';
  yield name;
  for (const [code, value] of codeValueEntries) {
    yield* serializeGroupValue(code, value as GroupValue);
  }
};
